export const CANDIDATE_PORTAL_ENABLED_LABEL = 'Enable Candidate Portal';

export const CANDIDATE_PORTAL_DATA_TEST_ID = 'candidate-portal-form';

export const CANDIDATE_PORTAL_ENABLING_DISCLAIMER =
  'When this setting is enabled, company users can configure candidate portal branding in Settings and turn the candidate portal on per role.';

export const CANDIDATE_PORTAL_DISABLING_DISCLAIMER =
  'When this setting is disabled, the candidate portal branding settings are hidden and roles cannot turn the candidate portal on. Saved branding is kept.';
